import {
  trackLoginClick,
  trackSignupClick,
} from "../../utils/GoogleTagTracking";
import { createSlice } from "@reduxjs/toolkit";

const initialState = { login: false, register: false, resetPassword: false };

export const onBoardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    toggleOnboard: (state, action) => {
      const { login, register, resetPassword } = action?.payload || {};
      if (login) {
        trackLoginClick();
      }
      if (register) {
        trackSignupClick();
      }

      state.login = login || false;
      state.register = register || false;
      state.resetPassword = resetPassword || false;
    },
  },
});

export const { toggleOnboard } = onBoardingSlice.actions;
export default onBoardingSlice.reducer;
